
import { defineComponent, computed, PropType } from 'vue';
import SidebarItem from './sidebar-item.vue';
import variables from '@/styles/variables/index.module.scss';
import { RouteLocationRaw, useRoute } from 'vue-router';
import { IMenuItem } from '@/store/menu/type.d';

interface Sidebar {
  opened: boolean;
  withoutAnimation: boolean;
}

export default defineComponent({
  name: 'AppSider',
  components: {
    SidebarItem,
  },
  props: {
    systemName: {
      type: String,
      default: 'ops运维管理系统',
    },
    logo: {
      type: String,
      default: '',
    },
    logoRoute: {
      type: [String, Object] as PropType<RouteLocationRaw>,
      default: () => ({
        path: '/',
      }),
    },
    menus: {
      type: Array as PropType<IMenuItem[]>,
      default: () => ([]),
    },
    isCollapse: {
      type: Boolean,
    },
    sidebar: {
      type: Object as PropType<Sidebar>,
      default: () => ({
        opened: false,
        withoutAnimation: true,
      }),
    },
  },
  setup(props) {
    const route = useRoute();
    const menuList = computed<IMenuItem[]>(() => {
      console.log(props.menus, 'props.menus');
      return props.menus;
    });
    const styleVariables = computed(() => {
      return variables;
    });

    const activeMenu = computed(() => {
      const { meta, name } = route;
      // if set path, the sidebar will highlight the path you set
      if (meta.activeMenu) {
        // return meta.activeMenu;
        return typeof meta.activeMenu === 'function' ? meta.activeMenu(route) : meta.activeMenu;
      }
      return name;
    });

    return {
      activeMenu,
      variables: styleVariables,
      menuList,
      // isCollapse,
      defaultOpeneds: ['/sample-demand', '/user-management'],
    };
  },
});
